"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolyfillReactIntl = void 0;
exports["default"] = IntlProvider;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Default context for React-Intl polyfill. Locale is ignored by default, builds should be locale specific.
var PolyfillReactIntl = exports.PolyfillReactIntl = /*#__PURE__*/(0, _react.createContext)({
  messages: {}
});

/**
 * Context provider for internationalized messages.
 *
 * @param {object} messages Messages dictionary.
 * @param {Array<ReactElement>} children React renderable nodes.
 * @returns {ReactElement} React-intl polyfill provider.
 * @public
 */
function IntlProvider(_ref) {
  var messages = _ref.messages,
    children = _ref.children;
  var value = {
    messages: messages
  };
  return /*#__PURE__*/_react["default"].createElement(PolyfillReactIntl.Provider, {
    value: value
  }, children);
}
IntlProvider.propTypes = {
  messages: _propTypes["default"].object,
  children: _propTypes["default"].node
};